const timeMinutes = (value) => {
  if (value === '24:00') return 1440;
  const match = /^(\d{2}):(\d{2})$/.exec(String(value || ''));
  if (!match || Number(match[1]) > 23 || Number(match[2]) > 59) return null;
  return Number(match[1]) * 60 + Number(match[2]);
};

export const OUT_OF_SCHEDULE_DURATION_MINUTES = 15;

export function publicBookingBlocks(config) {
  const blocks = config?.bookingBlocks;
  if (!blocks || typeof blocks !== 'object' || Array.isArray(blocks)) return [];
  return Object.entries(blocks).flatMap(([id, block]) => {
    if (!block || !/^\d{4}-\d{2}-\d{2}$/.test(block.dateKey || '')) return [];
    const start = timeMinutes(block.start);
    const end = timeMinutes(block.end);
    if (start == null || end == null || start >= end) return [];
    return [{ ...block, id, timeKey: block.start, isBlock: true }];
  });
}

// Intervals are half-open: a booking may end exactly when a block starts.
export function overlapsPublicBookingBlock(config, dateKey, timeKey, durationMinutes) {
  const start = timeMinutes(timeKey);
  const duration = Number(durationMinutes);
  if (start == null || !Number.isFinite(duration) || duration <= 0) return false;
  return publicBookingBlocks(config).some(block => block.dateKey === dateKey
    && start < timeMinutes(block.end) && start + duration > timeMinutes(block.start));
}

export function publicBookingDuration(config, dateKey, timeKey) {
  const override = config?.dateOverrides?.[dateKey];
  const ranges = Array.isArray(override) ? override : (override?.ranges || override?.slots || []);
  const duration = value => Number(value) >= 5 ? Math.round(Number(value)) : Math.max(5, Number(config?.slotMinutes) || 20);
  const start = timeMinutes(timeKey);
  const range = ranges.find((item) => {
    const rangeStart = timeMinutes(item.start);
    const rangeEnd = timeMinutes(item.end);
    const slotMinutes = duration(item.slotMinutes);
    return start != null
      && rangeStart != null
      && rangeEnd != null
      && start >= rangeStart
      && start + slotMinutes <= rangeEnd
      && (start - rangeStart) % slotMinutes === 0;
  });
  if (range) return duration(range.slotMinutes);
  return OUT_OF_SCHEDULE_DURATION_MINUTES;
}

export function currentPublicBookingRows(bookings, blocks, selectedDate, today) {
  const visibleBlocks = blocks.filter(block => selectedDate ? block.dateKey === selectedDate : block.dateKey >= today);
  return [...bookings, ...visibleBlocks].sort((a, b) =>
    `${a.dateKey} ${a.timeKey}`.localeCompare(`${b.dateKey} ${b.timeKey}`)
    || Number(Boolean(b.isBlock)) - Number(Boolean(a.isBlock)));
}
